import { render } from "./ElementLabel.vue?vue&type=template&id=372d8f4f"
import script from "./ElementLabel.vue?vue&type=script&lang=js"
export * from "./ElementLabel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__